import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useLoginVerify } from '../data/useLoginVerify';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { HubSpotForm } from 'portals-platform-lib';
import { usePreviewContext } from '../hooks/usePreviewContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketCreation({
  onSuccess,
  formData,
  portalData
}) {
  const loginVerify = useLoginVerify();
  const history = useHistory();
  const {
    email
  } = loginVerify.data || {};
  const {
    search: previewSearch,
    hash: previewHash
  } = usePreviewContext();
  const {
    portalId,
    env,
    hublet
  } = portalData;
  const originalParamsRef = useRef(null);
  useEffect(() => {
    if (!originalParamsRef.current) {
      originalParamsRef.current = new URLSearchParams(window.location.search);
    }

    //TODO: Replace with a way to directly pass email down to PP
    const params = new URLSearchParams(previewSearch);
    if (email) {
      params.set('email', email);
    }
    history.replace({
      search: params.toString(),
      hash: previewHash
    });
    return () => {
      var _originalParamsRef$cu;
      return history.replace({
        search: (_originalParamsRef$cu = originalParamsRef.current) === null || _originalParamsRef$cu === void 0 ? void 0 : _originalParamsRef$cu.toString(),
        hash: previewHash
      });
    };
  }, [email, history, previewSearch, previewHash]);
  const onFormSubmitted = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('customer-portal-app.ticketSubmittedAlert.message'),
      titleText: I18n.text('customer-portal-app.ticketSubmittedAlert.title'),
      type: 'success'
    });
    onSuccess();
  }, [onSuccess]);
  if (!formData) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    });
  }
  return /*#__PURE__*/_jsx(HubSpotForm, {
    formId: formData.formGuid,
    editorVersion: formData.formCreatedByEditorV2 ? 2 : 1,
    portalId: portalId,
    env: env,
    region: hublet,
    onFormSubmitted: onFormSubmitted,
    loadingFallback: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    })
  });
}